export default "__VITE_ASSET__CYUXs9Ae__"